import { ReloadOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Button, Flex, Result } from 'antd';

const defaultSubTitle =
  'Es tut uns leid, aber Sie haben derzeit keinen Zugriff auf diesen Bereich von labcomplete®. Um Anforderungen erstellen zu können, benötigen Sie spezielle Berechtigungen. Bitte wenden Sie sich an Ihr Labor, um diese zu erhalten.';

export const NoAccess = ({ subTitle = defaultSubTitle, showReload = true }: { subTitle?: string; showReload?: boolean }) => {
  return (
    <Flex justify="center">
      <Result
        className={css`
          max-width: 800px;
        `}
        status={403}
        title="Laboranforderungen"
        subTitle={subTitle}
        extra={
          showReload && (
            <Button icon={<ReloadOutlined />} onClick={() => (window.location.href = '/')} type="primary">
              Applikation neu laden
            </Button>
          )
        }
      />
    </Flex>
  );
};
